import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ColumnOption } from "../../../constants/schema.js";
import { isListed } from "../dictionary/membership.js";
import { addColumnAction, changeColumnCommentAction, changeColumnDataTypeAction, changeColumnDefaultAction, changeColumnDomainAction, changeColumnLogicalNameAction, changeColumnNameAction, changeColumnNotNullAction } from "../table-column/atom.actions.js";
import { toReferenceDataType } from "./referenceType.js";
import { bHas } from "../../../utils/bit.js";
//#region src/engine/modules/relationship/fkColumns.ts
var SEPARATOR = "_";
var getStartKeyColumns = (collections, startTable) => query(collections).collection("tableColumnEntities").selectByIds(startTable.columnIds).filter(({ options }) => bHas(options, ColumnOption.primaryKey));
var toNameKey = (name) => name.trim().toLowerCase();
var WORD_CHARACTERS = /^[\p{L}\p{M}\p{N}]+$/u;
var CASE_BOUNDARY = /\p{Ll}\p{Lu}|\p{Lu}\p{Lu}\p{Ll}|[\p{Lo}\p{Lm}][\p{Lu}\p{Ll}]|[\p{Lu}\p{Ll}][\p{Lo}\p{Lm}]/u;
var MARKS_AND_DIGITS = /[\p{M}\p{N}]/gu;
var isSingleWord = (name) => WORD_CHARACTERS.test(name) && !CASE_BOUNDARY.test(name.replace(MARKS_AND_DIGITS, ""));
function prefixKeyName(tableName, keyName) {
	const table = tableName.trim();
	const key = keyName.trim();
	if (!table || !isSingleWord(key) || toNameKey(key) === toNameKey(table)) return key;
	return `${table}${SEPARATOR}${key}`;
}
function claimName(base, taken) {
	let name = base;
	for (let suffix = 2; taken.has(toNameKey(name)); suffix++) name = `${base}${SEPARATOR}${suffix}`;
	taken.add(toNameKey(name));
	return name;
}
function toForeignKeyNames(startTableName, keyNames, endColumnNames) {
	const taken = new Set(endColumnNames.map(toNameKey).filter(Boolean));
	const bases = keyNames.map((keyName) => prefixKeyName(startTableName, keyName));
	const isKept = (index) => bases[index] === keyNames[index].trim();
	const indexes = bases.map((_, index) => index);
	const clashing = [...indexes.filter(isKept), ...indexes.filter((index) => !isKept(index))].filter((index) => {
		const key = toNameKey(bases[index]);
		const clashes = taken.has(key);
		if (key) taken.add(key);
		return clashes;
	});
	const names = [...bases];
	for (const index of clashing) names[index] = claimName(bases[index], taken);
	return names;
}
var toForeignKeyActions = (startColumns, endTableId, endColumnIds, { startTableName, endColumnNames, database, domainIds = [] }) => {
	const names = toForeignKeyNames(startTableName, startColumns.map(({ name }) => name), endColumnNames);
	return startColumns.flatMap((startColumn, index) => {
		const payload = {
			id: endColumnIds[index],
			tableId: endTableId
		};
		const dataType = toReferenceDataType(startColumn.dataType, database);
		const domainId = dataType === startColumn.dataType && isListed(domainIds, startColumn.domainId) ? startColumn.domainId : "";
		return [
			addColumnAction(payload),
			changeColumnNotNullAction({
				...payload,
				value: true
			}),
			changeColumnNameAction({
				...payload,
				value: names[index]
			}),
			changeColumnDataTypeAction({
				...payload,
				value: dataType
			}),
			changeColumnDefaultAction({
				...payload,
				value: startColumn.default
			}),
			changeColumnCommentAction({
				...payload,
				value: startColumn.comment
			}),
			...startColumn.logicalName ? [changeColumnLogicalNameAction({
				...payload,
				value: startColumn.logicalName
			})] : [],
			...domainId ? [changeColumnDomainAction({
				...payload,
				value: domainId
			})] : []
		];
	});
};
//#endregion
export { getStartKeyColumns, isSingleWord, prefixKeyName, toForeignKeyActions, toForeignKeyNames, toNameKey };
